const Compress = ({ colour = '#ADB6B9', width = 22, height = 22, ...props }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M1.00002 23.0002L9.24927 14.751"
      stroke={colour}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.91786 14.751H9.2522V22.0853"
      stroke={colour}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M23 1L14.7508 9.24924" stroke={colour} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M22.082 9.24929H14.7477V1.91797"
      stroke={colour}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Compress;
